import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGuestCardsActivitiesStatistics } from './queries/queries';
import GuestCardActivitiesWidget from '../../common/widgets/guestCardActivities';
import DataProcessor from '../../common/dataProcessors/guestCardActivitiesDataProcessor';
import { IaksByTypeDistribution } from '../../common/charts/iaksByTypeDistribution';
import { IaksByDayDistribution } from '../../common/charts/iaksByDayDistribution';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GuestCardActivities extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.weekly.guestCardActivities;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'week');
  }

  render() {
    return (
      <GuestCardActivitiesWidget data={this.dataProcessor.data} title="Weekly Guest Card Activities"
                                 loading={this.props.data.loading} comment={this.comment}>
        <IaksByDayDistribution data={this.dataProcessor.byDayChartData} barTooltip={this.dataProcessor.byDayBarTooltip} />
        <IaksByTypeDistribution data={this.dataProcessor.byTypeChartData} />
      </GuestCardActivitiesWidget>
    );
  }
}

export default compose(
  graphql(getGuestCardsActivitiesStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GuestCardActivities);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/weekly/guestCardActivities.js